"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniformDistributionIcon = void 0;
//add width and height props to svg
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const colors_1 = require("../../../../../assets/styles/colors");
const UniformDistributionIcon = ({ color = colors_1.gray300, width = 10, height = 20, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("svg", { width: width, height: height, viewBox: "0 0 10 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": t("thresholdConfigurator.altUniformDistribution") },
        react_1.default.createElement("path", { d: "M9 15.25L5.25 19M5.25 19L1.5 15.25M5.25 19L5.25 1", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M1.5 4.75L5.25 1M5.25 1L9 4.75M5.25 1L5.25 19", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.UniformDistributionIcon = UniformDistributionIcon;
